import { useModoConsultaEvaluacion } from '../../../../hooks/useModoConsultaEvaluacion';
import React, { useState, useContext } from 'react';
import { AppContext } from '../../../../Context';
import { collection, addDoc } from "firebase/firestore";
import { db } from '../../../../firebase/firebase';
import { Form, Button, Container, Card, Row, Col, Table } from 'react-bootstrap';
import Swal from 'sweetalert2';

const M13_Ejercicio7 = ({ cerrarModal }) => {
    const { currentUser } = useContext(AppContext);
    const modoConsulta = useModoConsultaEvaluacion();
    const [step, setStep] = useState(1);
    
    const [respuestas, setRespuestas] = useState({
        comprension: {
            conceptos_clave: '',
            listas: '',
            procesos: '',
            tabla_estructurada: '',
            reglas_recomendaciones: ''
        },
        bloques: {
            conceptuales: '',
            funcionales: '',
            visuales: ''
        },
        planificacion: {
            lunes: { clases: '', casa: '', instituto: '', libre: '' },
            martes: { clases: '', casa: '', instituto: '', libre: '' },
            miercoles: { clases: '', casa: '', instituto: '', libre: '' },
            jueves: { clases: '', casa: '', instituto: '', libre: '' },
            viernes: { clases: '', casa: '', instituto: '', libre: '' },
            sabado: { clases: '', casa: '', instituto: '', libre: '' },
            domingo: { clases: '', casa: '', instituto: '', libre: '' }
        },
        optimizacion: {
            beneficios: '',
            descanso: '',
            orden_estudio: ''
        }
    });

    const textoBase = `PLANIFICACIÓN Y DEFINICIÓN DEL MÉTODO DE ESTUDIO  
EJERCICIO 7: DE COMPRENSIÓN  

Cuando se trata de estudio lo importante es la calidad, es decir, no es cuánto sino cómo se estudia. Si pasa horas leyendo y estudiando sin aprender mucho podemos considerarlo un tiempo muerto, esto no permite un rendimiento adecuado por lo tanto las calificaciones y el tiempo tampoco lo serán.  

Ya usted adquirió mayor velocidad y con buena comprensión; es hora de ponerlas en práctica a la hora de estudiar  

SER MENTALMENTE EFICIENTE  

El éxito en el estudio o capacitación no solo se apoya en la inteligencia individual sino en la eficacia de las técnicas o métodos de estudio que usted aplique y que se adapten a su necesidad.  

Recomendaciones de inicio  

¡Primero programe! Nunca estudie sin programarse. Planifique su estudio.  
Escoja el método adecuado sobre todo sin asignaturas densas o áridas, desde luego desde su punto de vista. Si trabaja sin método puede pasar que no aproveche adecuadamente su tiempo, cansancio prematuro enojo u ofuscación y por consecuencia su actitud no será la más adecuada.  

¿Cuál será el método más adecuado?  

Sacar esquemas  
Subrayar  
Repasar  
Preparar planes y horarios  

El objetivo es aprender a organizarse y trabajar en forma sistemática y racionalizada  

Iniciaremos por guiarnos en algunos fundamentos que existen para seleccionar y diseñar un buen método  

1.- ¿Qué objetivo se pretende seguir?  
2.- Sobre qué tema o materia se va a estudiar  
3.- Con qué medios o recursos cuenta  
4.- Qué procedimiento es el idóneo en cada circunstancia  
5.- Cuál es el orden más lógico en el que se deben aplicar los recursos y procedimientos para alcanzar el objetivo con seguridad, ahorro de tiempo y máximo rendimiento  
6.- Cuánto tiempo se tiene y a qué ritmo se debe trabajar para lograr el objetivo en el tiempo deseado  

Ahora bien, como individuos nuestras facultades son diferentes y, por lo que el método y el tiempo son muy personales, sin embargo hay aspectos fundamentales que se deben seguir.  

El estudiar se centra en cuatro habilidades importantes que son:  

Leer  
Escuchar  
Escribir  
Hablar  

El paso previo para escoger el método es la planificación, a continuación verá un ejemplo, usted puede realizar uno personal de acuerdo a sus necesidades:  

TABLA DE PLANIFICACIÓN  

Días | Horas de clases | Estudio en casa | Estudio en instituto | Tiempo libre  

Lunes  
Martes  
Miércoles  
Jueves  
Viernes  
Sábado  
Domingo  
Total de horas  

Si se trabaja o estudia de acuerdo con un plan, se ahorra tiempo y se garantiza un mejor rendimiento, potencializando las habilidades de cada uno.  

No confíe en su voluntad y capacidad. ¡Planifique! y verá mejores resultados.  

Programando sus horarios podrá:  

1.- Ahorrar tiempo y esfuerzo  
2.- Dar mayor eficacia  
3.- Uso adecuado y racional del tiempo  
4.- Usted mismo se obliga a cumplir el horario  
5.- Crea el hábito y la formación  
6.- Le da el tiempo a la capacidad de atención concentrada  
7.- Se genera un positivo sentimiento de confianza  
8.- Le proporciona satisfacción personal cumpliendo sus metas  

Tenga en cuenta que debe descansar, después de una hora de estudio descanse de 10 a 15 minutos; si excede el tiempo tendrá dificultades para lograr concentración. Si estudia durante dos horas seguidas, descanse 20 minutos, sin son tres horas, descanse 25 minutos, no prolongue más tiempo ya que esto bajará su rendimiento.  

Estudie las materias que no le sean gratas; después siga con las difíciles, y al final con las más sencillas. Esto le dará interés y capacidad de atención concentrada y no se cansará prematuramente.`;

    const handleComprensionChange = (campo, valor) => {
        setRespuestas(prev => ({
            ...prev,
            comprension: { ...prev.comprension, [campo]: valor }
        }));
    };

    const handleBloquesChange = (campo, valor) => {
        setRespuestas(prev => ({
            ...prev,
            bloques: { ...prev.bloques, [campo]: valor }
        }));
    };

    const handlePlanificacionChange = (dia, campo, valor) => {
        setRespuestas(prev => ({
            ...prev,
            planificacion: {
                ...prev.planificacion,
                [dia]: { ...prev.planificacion[dia], [campo]: valor }
            }
        }));
    };

    const handleOptimizacionChange = (campo, valor) => {
        setRespuestas(prev => ({
            ...prev,
            optimizacion: { ...prev.optimizacion, [campo]: valor }
        }));
    };

    const nextStep = () => {
        if (step < 4) setStep(step + 1);
    };

    const prevStep = () => {
        if (step > 1) setStep(step - 1);
    };

    const enviarResultados = async () => {
        if (modoConsulta) { cerrarModal?.(); return; }

        try {
            await addDoc(collection(db, "evaluaciones"), {
                userId: currentUser.uid,
                nombre: "Ejercicio 7 - Transformación visual de la información",
                nivel: "Avanzado",
                modulo: "13",
                createdAt: new Date(),
                tipo: "Transformación Visual",
                respuestas: respuestas
            });
            
            Swal.fire({
                title: '¡Ejercicio Completado!',
                text: 'Tus respuestas han sido guardadas exitosamente.',
                icon: 'success',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Excelente'
            }).then(() => {
                if (cerrarModal) cerrarModal();
            });
        } catch (error) {
            console.error("Error al guardar resultados:", error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Hubo un problema al guardar tus respuestas. Por favor, intenta nuevamente.'
            });
        }
    };

    return (
        <Container>
            <h3 className="text-center mb-4">Ejercicio 7 - Transformación Visual de la Información</h3>
            
            {step === 1 && (
                <div>
                    <Card className="mb-4 shadow-sm border-left-primary">
                        <Card.Body>
                            <Card.Title>FASE 1: Comprensión (Lectura)</Card.Title>
                            <Card.Text>Lee el siguiente texto cuidadosamente.</Card.Text>
                            <div className="p-3 bg-light rounded" style={{ whiteSpace: 'pre-wrap', textAlign: 'justify' }}>
                                {textoBase}
                            </div>
                        </Card.Body>
                    </Card>
                    <div className="d-flex justify-content-end mt-4">
                        <Button variant="primary" size="lg" onClick={nextStep}>Siguiente: Clasificación</Button>
                    </div>
                </div>
            )}

            {step === 2 && (
                <div>
                    <Card className="mb-4 shadow-sm border-left-warning">
                        <Card.Body>
                            <Card.Title>FASE 1: Clasificación de Contenido</Card.Title>
                            <Card.Text>Identifica y clasifica los diferentes tipos de contenido del texto.</Card.Text>
                        </Card.Body>
                    </Card>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label className="fw-bold text-primary">Conceptos clave:</Form.Label>
                            <Form.Control as="textarea" rows={3} placeholder="Identifica los conceptos principales..." value={respuestas.comprension.conceptos_clave} onChange={e => handleComprensionChange('conceptos_clave', e.target.value)} />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label className="fw-bold text-success">Listas:</Form.Label>
                            <Form.Control as="textarea" rows={3} placeholder="Señala las listas encontradas..." value={respuestas.comprension.listas} onChange={e => handleComprensionChange('listas', e.target.value)} />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label className="fw-bold text-info">Procesos:</Form.Label>
                            <Form.Control as="textarea" rows={3} placeholder="Describe los procesos identificados..." value={respuestas.comprension.procesos} onChange={e => handleComprensionChange('procesos', e.target.value)} />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label className="fw-bold text-warning">Tabla estructurada:</Form.Label>
                            <Form.Control as="textarea" rows={3} placeholder="Menciona las tablas o estructuras..." value={respuestas.comprension.tabla_estructurada} onChange={e => handleComprensionChange('tabla_estructurada', e.target.value)} />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label className="fw-bold text-secondary">Reglas y recomendaciones:</Form.Label>
                            <Form.Control as="textarea" rows={3} placeholder="Lista las reglas y recomendaciones..." value={respuestas.comprension.reglas_recomendaciones} onChange={e => handleComprensionChange('reglas_recomendaciones', e.target.value)} />
                        </Form.Group>
                    </Form>
                    <div className="d-flex justify-content-between mt-4">
                        <Button variant="secondary" onClick={prevStep}>Anterior</Button>
                        <Button variant="primary" size="lg" onClick={nextStep}>Siguiente: Bloques Visuales</Button>
                    </div>
                </div>
            )}

            {step === 3 && (
                <div>
                    <Card className="mb-4 shadow-sm border-left-success">
                        <Card.Body>
                            <Card.Title>FASE 2: Bloques Visuales</Card.Title>
                            <Card.Text>Transforma la información en representaciones visuales.</Card.Text>
                        </Card.Body>
                    </Card>
                    
                    <Row className="justify-content-center mb-4">
                        <Col md={4}>
                            <Card className="h-100 shadow-sm border-primary">
                                <Card.Header className="bg-primary text-white text-center fw-bold">Bloques Conceptuales</Card.Header>
                                <Card.Body>
                                    <Form.Control 
                                        as="textarea" 
                                        rows={5} 
                                        placeholder="Método de estudio, recomendaciones, preguntas guía, objetivo..." 
                                        value={respuestas.bloques.conceptuales}
                                        onChange={e => handleBloquesChange('conceptuales', e.target.value)}
                                        className="border-0"
                                        style={{ resize: 'none', boxShadow: 'none' }}
                                    />
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className="h-100 shadow-sm border-success">
                                <Card.Header className="bg-success text-white text-center fw-bold">Bloques Funcionales</Card.Header>
                                <Card.Body>
                                    <Form.Control 
                                        as="textarea" 
                                        rows={5} 
                                        placeholder="Leer, escuchar, escribir, hablar..." 
                                        value={respuestas.bloques.funcionales}
                                        onChange={e => handleBloquesChange('funcionales', e.target.value)}
                                        className="border-0"
                                        style={{ resize: 'none', boxShadow: 'none' }}
                                    />
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className="h-100 shadow-sm border-info">
                                <Card.Header className="bg-info text-white text-center fw-bold">Bloques Visuales</Card.Header>
                                <Card.Body>
                                    <Form.Control 
                                        as="textarea" 
                                        rows={5} 
                                        placeholder="Representaciones visuales directas..." 
                                        value={respuestas.bloques.visuales}
                                        onChange={e => handleBloquesChange('visuales', e.target.value)}
                                        className="border-0"
                                        style={{ resize: 'none', boxShadow: 'none' }}
                                    />
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>

                    <Card className="mb-4 shadow-sm">
                        <Card.Body>
                            <Card.Title className="text-center">FASE 3: Tabla de Planificación</Card.Title>
                            <Table responsive striped bordered hover className="mt-3">
                                <thead className="table-dark">
                                    <tr>
                                        <th>Día</th>
                                        <th>Horas de clases</th>
                                        <th>Estudio en casa</th>
                                        <th>Estudio en instituto</th>
                                        <th>Tiempo libre</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Object.entries(respuestas.planificacion).map(([dia, datos]) => (
                                        <tr key={dia}>
                                            <td className="fw-bold text-capitalize">{dia}</td>
                                            <td><Form.Control type="text" placeholder="0" value={datos.clases} onChange={e => handlePlanificacionChange(dia, 'clases', e.target.value)} /></td>
                                            <td><Form.Control type="text" placeholder="0" value={datos.casa} onChange={e => handlePlanificacionChange(dia, 'casa', e.target.value)} /></td>
                                            <td><Form.Control type="text" placeholder="0" value={datos.instituto} onChange={e => handlePlanificacionChange(dia, 'instituto', e.target.value)} /></td>
                                            <td><Form.Control type="text" placeholder="0" value={datos.libre} onChange={e => handlePlanificacionChange(dia, 'libre', e.target.value)} /></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </Card.Body>
                    </Card>

                    <div className="d-flex justify-content-between mt-4">
                        <Button variant="secondary" onClick={prevStep}>Anterior</Button>
                        <Button variant="primary" size="lg" onClick={nextStep}>Siguiente: Optimización</Button>
                    </div>
                </div>
            )}

            {step === 4 && (
                <div>
                    <Card className="mb-4 shadow-sm border-left-info">
                        <Card.Body>
                            <Card.Title>FASE 4: Optimización del Estudio</Card.Title>
                            <Card.Text>Reflexiona sobre los beneficios y reglas para optimizar tu estudio.</Card.Text>
                        </Card.Body>
                    </Card>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label className="fw-bold text-primary">Beneficios de programar horarios:</Form.Label>
                            <Form.Control as="textarea" rows={4} placeholder="Lista los 8 beneficios mencionados..." value={respuestas.optimizacion.beneficios} onChange={e => handleOptimizacionChange('beneficios', e.target.value)} />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label className="fw-bold text-success">Reglas de descanso:</Form.Label>
                            <Form.Control as="textarea" rows={3} placeholder="Describe las reglas de descanso por tiempo..." value={respuestas.optimizacion.descanso} onChange={e => handleOptimizacionChange('descanso', e.target.value)} />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label className="fw-bold text-warning">Orden de estudio de materias:</Form.Label>
                            <Form.Control as="textarea" rows={3} placeholder="1. No agradables 2. Difíciles 3. Fáciles..." value={respuestas.optimizacion.orden_estudio} onChange={e => handleOptimizacionChange('orden_estudio', e.target.value)} />
                        </Form.Group>
                    </Form>
                    <div className="d-flex justify-content-between mt-4">
                        <Button variant="secondary" onClick={prevStep}>Anterior</Button>
                        <Button variant="success" size="lg" onClick={enviarResultados}>Finalizar y Enviar</Button>
                    </div>
                </div>
            )}
        </Container>
    );
};

export default M13_Ejercicio7;